import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Paper } from '@material-ui/core'
import { connect } from 'react-redux'
import { Section } from './@types';
import FormDialog from '../../Components/FormDialog';
import { TextValidator } from 'react-material-ui-form-validator'
import MuiTheme from '../../MuiTheme';
import { ReduxStore } from '../../stores';
import { OSection } from './Model';
import { withRouter, RouteComponentProps } from 'react-router';
import { ThunkDispatch } from 'redux-thunk';
import { TAction } from 'loop-front';

interface IStateProps { }

interface IDispatchProps {
    submitForm?: (formData: Partial<Section>) => any
}

interface IState {
    showForm: boolean
    formData: Partial<Section>
    submittingForm: boolean
}

interface OwnProps {
    open: boolean
    section?: Section
    onClose?: () => void
}

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, RouteComponentProps<{ chapterId: string }>, OwnProps {

}

class Form extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showForm: this.props.open,
            formData: {
                name: '',
                chapterId: this.props.match.params['chapterId']
            },
            submittingForm: false
        }
    }

    componentDidMount() {
        const { section = undefined } = this.props;
        if (section) {
            this.setState({ formData: { ...this.state.formData, ...section } });
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            formData: { ...this.state.formData, [e.target['name']]: e.target['value'] }
        })
    }

    handleSubmit = async () => {
        this.setState({ submittingForm: true });
        const res = await this.props.submitForm!(this.state.formData).catch((error: any) => this.setState({ submittingForm: false }));
        if (res) {
            this.handleClose();
        }
        this.setState({ submittingForm: false });
    }

    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.setState({ showForm: false });
    }

    render() {
        const { classes } = this.props
        const { submittingForm, formData } = this.state;
        return (
            <div>
                <FormDialog
                    open={this.state.showForm}
                    onCloseButtonClick={this.handleClose}
                    title={'Add New Section'}
                    onSubmit={this.handleSubmit}
                    loading={submittingForm}
                >
                    <Paper className={classes.formPaper} >
                        <TextValidator
                            type='number'
                            placeholder='Section Number'
                            fullWidth
                            name='number'
                            value={formData.number || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            validators={['required', 'isPositive']}
                            errorMessages={['This field is required', 'Only positive numbers are allowed']}
                        />
                        <TextValidator
                            placeholder='Section Name'
                            fullWidth
                            name='name'
                            value={formData.name || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            className={classes.inputFieldHeight}
                        />
                    </Paper>
                </FormDialog>
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({

})

const mapDispatchToProps = (dispatch: ThunkDispatch<ReduxStore, {}, TAction>): IDispatchProps => ({
    submitForm: (formData: Partial<Section>) => dispatch(formData.id ? OSection.putItem(formData) : OSection.postItem(formData))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    formPaper: {
        boxSizing: 'border-box',
        width: 650,
        padding: 50,
        '& > div': {
            marginBottom: 20,
        },
    },
    inputFieldHeight: {
        height: 48,
        marginTop: 25
    },
})

export default withRouter(connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Form)))